import Vue from 'vue'
import Router from 'vue-router'
import Home from 'components/Home'
import AboutUs from 'components/company/aboutus'
import Culture from 'components/company/culture'
import Rnd from 'components/company/rnd'
import Knowledge from 'components/service/knowledge'
import Maintenance from 'components/service/maintenance'
import Rotation from 'components/service/rotation'
import Driving from 'components/service/driving'
import Sidewall from 'components/service/sidewall'
import Warranty from 'components/service/warranty'
import Download from 'components/service/download'
import News from 'components/media/news'
import NewsDetail from 'components/media/newsdetail'
import Video from 'components/media/video'
import Interaction from 'components/media/interaction'
import Products from 'components/product/products'
import ProductDetail from 'components/product/productdetail'
import SwiperTest from 'components/product/testswiper'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      component: Home
    },
    {
      path: '/company',
      component: AboutUs
    },
    {
      path: '/company/aboutus',
      component: AboutUs
    },
    {
      path: '/company/culture',
      component: Culture
    },
    {
      path: '/company/rnd',
      component: Rnd
    },
    {
      path: '/service',
      component: Knowledge
    },
    {
      path: '/service/knowledge',
      component: Knowledge
    },
    {
      path: '/service/maintenance',
      component: Maintenance
    },
    {
      path: '/service/rotation',
      component: Rotation
    },
    {
      path: '/service/driving',
      component: Driving
    },
    {
      path: '/service/sidewall',
      component: Sidewall
    },
    {
      path: '/service/warranty',
      component: Warranty
    },
    {
      path: '/service/download',
      component: Download
    },
    {
      path: '/media',
      component: News
    },
    {
      path: '/media/news',
      component: News
    },
    {
      path: '/media/news/:id',
      component: NewsDetail,
      props: true
    },
    {
      path: '/media/video',
      component: Video
    },
    {
      path: '/media/interaction',
      component: Interaction
    },
    {
      path: '/products',
      component: Products
    },
    {
      path: '/product_detail/:id',
      component: ProductDetail,
      props: true
    },
    {
      path: '/products/swiper',
      component: SwiperTest
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js